import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import StoryBody from "../StoryBody";
import styles from "./PrimaryImage.css";

// Import the lazyloading module if the window context is defined.
if (typeof window !== "undefined") {
  import("lazysizes");
}

class PrimaryImage extends Component {
  render() {
    const { image } = this.props;

    if (!image || !Object.keys(image).length) {
      return null;
    } // APIs are inconsistent between null and empty object

    // Handle entity maps, add "caption" type
    const captionBlocks = image.caption &&
      image.caption.blocks && {
        ...image.caption,
        blocks: image.caption.blocks.map(block => ({
          ...block,
          type: "caption",
        })),
      };

    return (
      <figure>
        <div className={styles.imageWrapper}>
          <div className={styles.placeholder}>
            {this.props.lazyload ? (
              <img
                className={classNames(styles.img, "lazyload")}
                data-src={image.crops["16x9"].url}
                alt={image.alt_text}
              />
            ) : (
              <img
                className={styles.img}
                src={image.crops["16x9"].url}
                alt={image.alt_text}
              />
            )}
          </div>
        </div>
        {captionBlocks && (
          <figcaption className={styles.caption}>
            <StoryBody story={{ blocks: captionBlocks }} />
          </figcaption>
        )}
      </figure>
    );
  }
}

PrimaryImage.defaultProps = {
  lazyload: true,
};

PrimaryImage.propTypes = {
  lazyload: PropTypes.bool,
  image: PropTypes.shape({
    alt_text: PropTypes.string,
    crops: PropTypes.shape({
      "16x9": PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  }),
};

export default PrimaryImage;
